<template>  
  <div :id="paneID" >
    <div class="row items-center text-h5 text-center q-pa-sm bg-primary text-white result-pane-header-row">
      <div class="col-3 print-hide">
        <div class="row">
          <q-btn icon="arrow_back" @click="browserBack" class="q-mr-sm q-pl-sm q-pr-sm" aria-label="Go back">
            <q-tooltip>Go back to your previous screen</q-tooltip>
          </q-btn>
          <div class="pointer shadow-1 q-pl-xs q-pr-xs" >
            <q-icon  v-svg="getIcon('selectArea')"  size="md"  @click="router.push('/select'), clearMapStyle(), loadDataByID('FLAGS', null)"/>
            <q-tooltip>Go back to enter an area of interest</q-tooltip>
          </div>
        </div>

      </div>
      <div class="col-8">
        <!-- Spotlight: {{ AllCodes[activeSpSpotlight] }} -->
        <div class="col-5 q-ma-sm"><SpSpotSelect :width="250" label="Select a species"  bg-color="white" /></div>
      </div>
      <div class="col-1 print-hide">
          <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print(paneID, null, AllCodes[activeSpSpotlight])" v-if="!printing" aria-label="Print spotlight">
            <q-tooltip>Print this panel to PDF</q-tooltip>
          </q-btn>
          <q-spinner v-else />
      </div>
    </div>
    <!-- <div class="row q-mt-sm print-hide justify-center">
      <div class="col-5 q-ma-sm"><SpSpotSelect :width="250" label="Select a species" color="white"/></div>
    </div> -->
    <q-separator />
    <q-scroll-area :style="{'height': 'calc(100vh - 180px)', 'max-width': resultContentColWidth}" ref="resultContentCol">
      <div class="text-h6 underline text-bold text-uppercase  q-ma-sm"> {{ AllCodes[activeSpSpotlight] }}</div>
      <div class="q-pa-xs">
        <q-list bordered class="rounded-borders bottom-border" role="list">
          <q-expansion-item dense class="exp-panel" v-model="abundance" header-class="text-bold text-uppercase" expand-separator group="spSpotlight" label="Important Areas">
            <q-tabs align="left" active-color="secondary" dense class="q-mt-sm" v-model="spotlightTabs" >
              <q-tab name="dependence"  label="Dependence on the Region"/>    
              <q-tab name="abundance" label="Abundance Estimates"/>
            </q-tabs>
            <q-tab-panels dense v-model="spotlightTabs" class="outlined">
              <q-tab-panel name="dependence"  class="q-pa-xs">
                <q-card class="q-pa-md">
                  <div class="text-caption">
                    From all the core areas for {{ AllCodes[activeSpSpotlight] }} across the US Atlantic region, the graph below shows the percent that falls within each month and ecoregion.  Click on a bubble to see the abundance data in the map.
                  </div>
                  <div class="text-h6 q-pt-md">
                    % of all Atlantic core areas within each ecoregion
                    <q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['coreArea'].model = !infoDialogs['coreArea'].model" aria-label="Core area help"/>
                  </div>
                  <div class="row items-center" >
                    <div class="col-1 vert-word" v-if="offshoreDataAvailable"><div class="text-bold rotated-text">Offshore</div></div>
                    <div class="col-11" v-if="offshoreDataAvailable">          
                      <DonutTable 
                        :version="null"
                        :rows="birdEcoregSummaryTableData" 
                        :columns="monthColumns"
                        title=""
                        :expandRows="false"
                        :mapStyle="true"
                        :mapStops="stops['spp_95max']"
                        :mapClassNames="max95LegendColorStopNames"
                        :cellColors="birdDonutCellColors"
                        :labelCells="false"
                        mapLayer="BIRD_MONTH"
                        :mapLegendTitles="birdMonthLegendTitles"
                        :breedingSeasons="breedingSeasons[activeSpSpotlight]"
                        :donuts="donuts"
                        :flat="true"
                        :hideBottom="true"
                        :hideBreeding="true"
                        :dependence="true"
                      />
                    </div>
                  </div>
                  <div class="row items-center" >
                    <div class="col-1 vert-word" v-if="coastalDataAvailable" >
                      <div class="text-bold rotated-text">Coastal</div>
                    </div>
                    <div class="col-11" v-if="coastalDataAvailable">
                      <DonutTable 
                          :version="null"
                          :rows="coastalBirdEcoregSummaryTableData" 
                          :columns="monthColumns"
                          title=""
                          :expandRows="false"
                          :mapStyle="true"
                          :mapStops="stops['spp_90maxW50']"
                          :mapClassNames="max90w50LegendColorStopNames"
                          :cellColors="birdDonutCellColors"
                          :labelCells="false"
                          mapLayer="COASTAL_BIRD_MONTH"
                          :mapLegendTitles="birdMonthLegendTitles"
                          :breedingSeasons="breedingSeasons[activeSpSpotlight]"
                          :coastal="true"
                          :donuts="donuts"
                          :flat="true"
                          :hideBottom="true"
                          :showLegend="false"
                          :hideHeader="hideHeader"
                          :hideBreeding="true"
                          :dependence="true"
                      />
                    </div>
                  </div>
                  <div class="custom-footer q-mt-lg">
                    <div class="custom-div-left">
                      <div class="row">
                        <div class="col-4 q-pl-md" v-if="breedingSeasons[activeSpSpotlight]">
                          <div class="row">
                            <div class="col-2 bg-teal-6 q-mr-xs">&nbsp</div>
                            <div class="col">Breeding Season</div>
                          </div>
                          <div class="row">
                            <div class="col-2 bg-teal-2 q-mr-xs">&nbsp</div>
                            <div class="col">Migration</div>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="row">
                            <div class="col-1"><q-icon name="circle" color="green-10" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="green-8" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="green-6" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="green-4" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="green-2" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="grey-2" size="md"/></div><div class="col-1"></div>
                          </div>
                          <div class="row">
                            <div class="col-2"> >50%</div>
                            <div class="col-2 q-pl-xs"> >40%</div>
                            <div class="col-2 q-pl-xs"> >30%</div>
                            <div class="col-2 q-pl-xs"> >20%</div>
                            <div class="col-2 q-pl-xs"> >1%</div>
                            <div class="col-2 q-pl-xs"> &lt1% </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </q-card>
              </q-tab-panel>
              <q-tab-panel name="abundance"  class="q-pa-xs">
                <q-card class="q-pa-md">
                  <div class="text-caption">The following information summarizes percent of {{ AllCodes[activeSpSpotlight] }} core habitats in each ecoregion.  Core habitats offshore are those in the 'Very High' class while in coastal areas, core habitats are based on the 'High' and 'Very High' classes.</div>
                  <!-- <div class="row text-caption q-pt-md items-center">
                    <div class="col-8">
                      <div v-if="!donuts" class="text-h6">% Core Area in the Ecoregion</div>
                      <div v-if="donuts" class="text-h6">All Abundance Classes</div>
                    </div>
                    <div class="col-4">
                      <q-toggle v-model="donuts" class="q-ml-lg" size="sm" aria-label="Select percent in very high or donat graphs with all classes" :label="donuts ? 'View % very high' : 'View all classes'"/>
                    </div>
                  </div> -->

                  <div class="text-h6">Abundance estimates</div>
                  <div class="row items-center" >
                    <div class="col-1 vert-word" v-if="offshoreDataAvailable"><div class="text-bold rotated-text">Offshore</div></div>
                    <div class="col-11" v-if="offshoreDataAvailable">          
                      <DonutTable 
                        :version="null"
                        :rows="birdEcoregSummaryTableData" 
                        :columns="monthColumns"
                        title=""
                        :expandRows="false"
                        :mapStyle="true"
                        :mapStops="stops['spp_95max']"
                        :mapClassNames="max95LegendColorStopNames"
                        :cellColors="birdDonutCellColors"
                        :labelCells="false"
                        mapLayer="BIRD_MONTH"
                        :mapLegendTitles="birdMonthLegendTitles"
                        :breedingSeasons="breedingSeasons[activeSpSpotlight]"
                        :donuts="donuts"
                        :flat="true"
                        :hideBottom="true"
                        :hideBreeding="true"
                      />
                    </div>
                  </div>
                  <div class="row items-center" >

                    <div class="col-1 vert-word" v-if="coastalDataAvailable" >
                      <div class="text-bold rotated-text">Coastal</div>
                    </div>
                    <div class="col-11" v-if="coastalDataAvailable">
                      <DonutTable 
                          :version="null"
                          :rows="coastalBirdEcoregSummaryTableData" 
                          :columns="monthColumns"
                          title=""
                          :expandRows="false"
                          :mapStyle="true"
                          :mapStops="stops['spp_90maxW50']"
                          :mapClassNames="max90w50LegendColorStopNames"
                          :cellColors="birdDonutCellColors"
                          :labelCells="false"
                          mapLayer="COASTAL_BIRD_MONTH"
                          :mapLegendTitles="birdMonthLegendTitles"
                          :breedingSeasons="breedingSeasons[activeSpSpotlight]"
                          :coastal="true"
                          :donuts="donuts"
                          :flat="true"
                          :hideBottom="true"
                          :showLegend="false"
                          :hideHeader="hideHeader"
                          :hideBreeding="true"
                      />
                    </div>
                  </div>

                  <div class="custom-footer q-mt-lg">
                    <div class="custom-div-left">
                      <div class="row">
                        <div class="col-4 q-pl-md" v-if="breedingSeasons[activeSpSpotlight]">
                          <div class="row">
                            <div class="col-2 bg-teal-6 q-mr-xs">&nbsp</div>
                            <div class="col">Breeding Season</div>
                          </div>
                          <div class="row">
                            <div class="col-2 bg-teal-2 q-mr-xs">&nbsp</div>
                            <div class="col">Migration</div>
                          </div>
                        </div>
                        <div class="col-6" v-if="!donuts">
                          <div class="row">
                            <div class="col-1"><q-icon name="circle" color="purple-10" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="purple-8" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="purple-6" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="purple-4" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="purple-2" size="md"/></div><div class="col-1"></div>
                            <div class="col-1"><q-icon name="circle" color="grey-2" size="md"/></div><div class="col-1"></div>
                          </div>
                          <div class="row">
                            <div class="col-2"> >50%</div>
                            <div class="col-2 q-pl-xs"> >40%</div>
                            <div class="col-2 q-pl-xs"> >30%</div>
                            <div class="col-2 q-pl-xs"> >20%</div>
                            <div class="col-2 q-pl-xs"> >1%</div>
                            <div class="col-2 q-pl-xs"> &lt1% </div>
                          </div>
                        </div>
                        <div class="col-8 q-lm-lg" v-else>
                          <div class="row items-center justify-center text-center q-mt-sm">
                            <div class="col-3 q-pa-xs" :style="{'background-color' : birdDonutCellColors['Very High'], 'color': 'white'}">Very High</div>
                            <div class="col-2 q-pa-xs" :style="{'background-color' : birdDonutCellColors['High']}">High</div>
                            <div class="col-2 q-pa-xs" :style="{'background-color' : birdDonutCellColors['Medium']}">Medium</div>
                            <div class="col-2 q-pa-xs" :style="{'background-color' : birdDonutCellColors['Low']}">Low</div>
                            <div class="col-3  q-pa-xs" :style="{'background-color' : birdDonutCellColors['No Data']}">No Data</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </q-card>
              </q-tab-panel>

            </q-tab-panels>

          </q-expansion-item>
          <q-expansion-item dense group="spSpotlight"  class="exp-panel" header-class="text-bold text-uppercase" expand-separator label="Important Habitats">
            <q-card class="q-pa-md">
              <div class="row q-mt-sm" @click="handleClick" :innerHTML="Habitats[activeSpSpotlight]"></div>
              <div class=""  v-if="CriticalHabitatMap[activeSpSpotlight]">
                <div class="text-body1 text-bold q-pt-lg">Critical Habitat</div>
                <q-separator class="q-mr-lg" color="primary" />
                <div class="row" >
                  <div class="col-7" :innerHTML="CriticalHabitatMap[activeSpSpotlight]"></div>
                  <div class="col-1 items-center self-center bordered pointer" :class="mapStyleInfo['attr'] == activeSpSpotlight ? 'mapActive' : ''"  @click="viewCriticalHabitat">
                    <q-icon class="self-center q-pb-md" v-if="mapStyleInfo['attr'] !== activeSpSpotlight || mapStyleInfo['attr'] =='' || mapStyleInfo['attr'] == None" name="play_arrow" ></q-icon>
                    <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
                  </div>
                </div>
              </div>
            </q-card>
            
          </q-expansion-item>
          <q-expansion-item dense group="spSpotlight"  class="exp-panel" header-class="text-bold text-uppercase" expand-separator label="Management Considerations">
            <q-card class="q-pa-md">

              <div class="row q-mt-sm" @click="handleClick" :innerHTML="Management[activeSpSpotlight]"></div>
            </q-card>
          </q-expansion-item>
          <q-expansion-item dense group="spSpotlight"  class="exp-panel" header-class="text-bold text-uppercase" expand-separator label="Links and Other Resources">
            <q-card class="q-pa-md">

              <div class="row q-mt-sm" @click="handleClick" :innerHTML="Links[activeSpSpotlight]"></div>
            </q-card>
          </q-expansion-item>
        </q-list>
           
      </div>
    </q-scroll-area>
  </div>
            
  <div v-for="(infoObj, name) in infoDialogs" :key="name" >
      <q-dialog v-model="infoObj.model">
          <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
      </q-dialog>
  </div>
  
</template>
<script setup lang="ts">
// @ts-nocheck
import { toRefs, ref, computed, onMounted, onUnmounted } from "vue";
import { QTableColumn } from 'quasar';
import { useRouter } from 'vue-router';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { AllCodes } from "../assets/SppCodesToNames.json"
import { stops } from "../assets/ColorStops.json"
import { Habitats, Management, Links, CriticalHabitatMap } from "../assets/SpSpotText.json"
import { CoastalBirdGroups } from "../assets/CoastalBirdGroups.json"
import { BIRD_MONTH, COASTAL_BIRD_MONTH } from "../assets/SpSpotlightEcoregData.json"
import SpSpotSelect from "./SpSpotSelect.vue";
import DonutTable from "./DonutTable.vue";
import { useSvgIcon } from '../composables/useSvgIcon';
import InfoDialog from "./InfoDialog.vue";
const { getIcon } = useSvgIcon();
const router = useRouter();
const {  map, loading, activeSpSpotlight, loadDataByID, clearMapStyle, setLegend, print, printing, ecos, setActiveHabSpotlight, activeLayerID, styleMap, mapStyleInfo } = useMapItems()
const { arrayFindObjectByProp, months, browserBack } = useHelpers();

const paneID = computed(() =>{
  return activeSpSpotlight.value + "spotlightPane"
})



const max90LegendColorStopNames ={
    '-9' : "No Data",
    "0" : "Very Low",
    "1" : "Low", 
    "75" : "Medium", 
    "90" : "High"
}
const max95LegendColorStopNames ={
    '-9' : "No Data",
    "0" : "Low",
    "75" : "Medium", 
    "90" : "High", 
    "95" : "Very High"
}
const max90w50LegendColorStopNames ={
    "-9": "No Data",
    "0": "Low",
    "50": "Medium",
    "75": "High",
    "90": "Very High"
}

const birdEcoregSummaryTableData = computed(() =>{
  const data = []
  const breedingSeason = breedingSeasons[activeSpSpotlight.value]
  // console.log(breedingSeason)

  
  for (const [ecoCode, ecoName] of Object.entries(ecos)) {
    if (["1", "2"].includes(ecoCode)){
      const ecoObj = {}
      // console.log(ecoCode)
      for (const [monthCode, monthName] of Object.entries(months)) {
        const attr = activeSpSpotlight.value + "_" + monthCode
        const areaVal = BIRD_MONTH[ecoCode][attr]
        // console.log(attr)
        // console.log(ecoCode)
        // console.log(areaVal)
        const donutObj = {}
        if (areaVal){
          for (const [densityCat, sqKM] of Object.entries(areaVal)) {
            if (parseInt(densityCat) > -9){ // exclude no data so that the donuts only show the offshore portion
              donutObj[max95LegendColorStopNames[densityCat]] = sqKM
            }
            
          }
          ecoObj[monthName] = donutObj // this isn't getting used now, but might be handy later if we want to show area in SQ km
          ecoObj['name'] = ecoName;
          ecoObj['ecoCode'] = ecoCode;
          ecoObj['spID'] = activeSpSpotlight.value; // used for map click on a table cell

          if (BIRD_MONTH[ecoCode][attr]){
            // console.log(BIRD_MONTH[ecoCode][attr]['max'])
            ecoObj['max'] = BIRD_MONTH[ecoCode][attr]['max']
          }
        
        }

        
      }
      // console.log(ecoObj)
      data.push(ecoObj)
    }
  }
  if (breedingSeason != undefined){
    data.push(breedingSeason)
  }
  return data
})

const coastalBirdEcoregSummaryTableData = computed(() =>{
  const data = []
  let noData = true

  

  for (const [ecoCode, ecoName] of Object.entries(ecos)) {
    if (["1", "2"].includes(ecoCode)){ // no coastal for Carolinian
      const ecoObj = {}
      // console.log(ecoCode)

      for (const [monthCode, monthName] of Object.entries(months)) {
        const attr = activeSpSpotlight.value + "_" + monthCode
        const areaVal = COASTAL_BIRD_MONTH[ecoCode][attr]
        const donutObj = {}
        for (const [densityCat, sqKM] of Object.entries(areaVal)) {
          if (parseInt(densityCat) > -9){ // exclude no data so that the donuts only show the coastal portion
            donutObj[max90w50LegendColorStopNames[densityCat]] = sqKM
            noData = false
          }
        }
        ecoObj[monthName] = donutObj // this isn't getting used now, but might be handy later if we want to show area in SQ km
        ecoObj['name'] = ecoName;
        ecoObj['ecoCode'] = ecoCode;
        ecoObj['spID'] = activeSpSpotlight.value; // used for map click on a table cell
        
        if (COASTAL_BIRD_MONTH[ecoCode][attr]){
          // console.log(COASTAL_BIRD_MONTH[ecoCode][attr]['max'])
          ecoObj['max'] = COASTAL_BIRD_MONTH[ecoCode][attr]['max']
        }
        
        
        
      }
      // console.log(ecoObj)
      data.push(ecoObj)
    }
  }
  data.push( breedingSeasons[activeSpSpotlight.value])
  // console.log(data)
  if (!noData){
    return data
  }
  else{
    return null
  }
  
  
})

const goToHabSpotlight = (hab) =>{
  // console.log(hab)
  router.push("habSpotlight")
  setActiveHabSpotlight(hab)

}
const handleClick = (event) => {
  // console.log(event)
  if (event.target.tagName === 'A' && event.target.dataset.func) {
    event.preventDefault();
    const funcName = event.target.dataset.func;
    const param = event.target.dataset.param;
    if (funcName === 'goToHabSpotlight') {
      goToHabSpotlight(param);
    }
  }
};

const breedingSeasons ={
    "AMBD": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "AMOY": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "AMWO": {"name" : "Breeding", "Jan": "pre", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "breed", "Sep": "breed", "Oct": "post", "Nov": "post", "Dec": "post"},
    "ARTE": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "ATPU": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "breed", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "", "Sep": "", "Oct": "", "Nov": "", "Dec": ""},
    "BLSC": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "breed", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "BBPL": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "BLSK": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "breed", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "BNST": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "BLTE": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "BOGU": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "BBSP": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "COEI": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "", "Aug": "", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "COLO": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "COTE": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "DUNL": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "EAME": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "breed", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "FOTE": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "GRCO": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "GRYE": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "GBTE": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "HADU": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "HOGR": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "KILLD": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "LEBI": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "LESA": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "LETE": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "breed", "May": "breed", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "LEYE": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "LBDO": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
	  "LTDU": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "MAGO": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "NOGA": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "", "May": "", "Jun": "breed", "Jul": "breed", "Aug": "", "Sep": "", "Oct": "", "Nov": "", "Dec": ""},
    "PESD": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "PIPL": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "PUSA": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "RAZO": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "breed", "May": "breed", "Jun": "", "Jul": "", "Aug": "", "Sep": "", "Oct": "", "Nov": "", "Dec": ""},
    "REKN": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "RNPH": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "ROST": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "ROYT": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "RUTU": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "RUBL": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "breed", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "SASP": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "breed", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "SAND": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "SEPL": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "SESA": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "SBDO": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "", "Oct": "", "Nov": "", "Dec": ""},
    "SOSA": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "SPSP": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "STSP": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "WESA": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "WHIM": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "post", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "WRSA": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "WILL": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "breed", "Jun": "breed", "Jul": "post", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "", "Dec": ""},
    "WIPL": {"name" : "Breeding", "Jan": "pre", "Feb": "pre", "Mar": "pre", "Apr": "breed", "May": "breed", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": ""},
    "WISN": {"name" : "Breeding", "Jan": "", "Feb": "pre", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
    "WWSC": {"name" : "Breeding", "Jan": "", "Feb": "", "Mar": "pre", "Apr": "pre", "May": "pre", "Jun": "breed", "Jul": "breed", "Aug": "post", "Sep": "post", "Oct": "post", "Nov": "post", "Dec": "post"},
  }

const findHighestValueKey = (obj) => {
    const result = {};
    for (const month in obj) {
        const values = obj[month];
        let highestKey = null;
        for (const key in values) {
            if (highestKey === null || key > highestKey) {
                highestKey = key;
            }
        }
        result[month] = highestKey;
        const areaValkey = `${month}_${highestKey}_sqkm`
        result[areaValkey] = obj[month][highestKey]
    }
    return result;
}

const coastalDataAvailable = computed(() =>{
  // is there coastal data for the selected species?
  let coastalPresent 
  if (Object.keys(COASTAL_BIRD_MONTH[1]).some(key => key.includes(activeSpSpotlight.value)) && 
      coastalBirdEcoregSummaryTableData.value && 
      coastalBirdEcoregSummaryTableData.value[1]['Jan'] !=''){
        coastalPresent = true
  }
  else{
    coastalPresent = false
  }
  return coastalPresent
})

const offshoreDataAvailable = computed(() =>{
  // is there offshore data for the selected species?
  let offshorePresent 
  if (Object.keys(birdEcoregSummaryTableData.value[1]).length >0 && birdEcoregSummaryTableData.value[1]['Jan'] !=''){
    offshorePresent = true
  }
  else{
    offshorePresent = false
  }
  return offshorePresent
})

const hideHeader = computed(() =>{
  // if there is only coastal bird data, show the month header row
  // if there is offshore and coastal data, hide the month header row
  // console.log(coastalDataAvailable.value)
  // console.log(offshoreDataAvailable)
  if (coastalDataAvailable.value && !offshoreDataAvailable.value ){
    return false
  }
  else{
    return true
  }
})

const hideBreeding = computed(() =>{
  // if there is only coastal bird data, show the month header row
  // if there is offshore and coastal data, hide the month header row
  // console.log(coastalDataAvailable.value)
  // console.log(offshoreDataAvailable)
  if (!coastalDataAvailable.value && offshoreDataAvailable.value ){
    return false
  }
  else{
    return true
  }
})

const viewCriticalHabitat = () =>{
  const lyrID = "SPOTLIGHT_CRITICALHABITAT"
  if (activeLayerID.value != lyrID){
      loadDataByID(lyrID, null)
  }
  const stopNames = {
    0 : "Not Critical Habitat",
    1: "Critical Habitat"
  }

  styleMap(lyrID, activeSpSpotlight.value, 'categorical', stops['sighting'], stopNames), 
  setLegend(AllCodes[activeSpSpotlight.value] + ' Critical Habitat', stops['sighting'], stopNames)
}

const monthColumns: QTableColumn[] = [
    { name: 'name', required: true, label: 'Ecoregion', align: 'left',field: 'name', sortable: false, style: 'padding-left: 3px; width: 55px; max-width: 55px;'},
    { name: 'Jan', align: 'center', label: 'Jan', field: 'Jan', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;'  },
    { name: 'Feb', align: 'center', label: 'Feb', field: 'Feb', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Mar', align: 'center', label: 'Mar', field: 'Mar', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Apr', align: 'center', label: 'Apr', field: 'Apr', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'May', align: 'center', label: 'May', field: 'May', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jun', align: 'center', label: 'Jun', field: 'Jun', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jul', align: 'center', label: 'Jul', field: 'Jul', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Aug', align: 'center', label: 'Aug', field: 'Aug', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Sep', align: 'center', label: 'Sep', field: 'Sep', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Oct', align: 'center', label: 'Oct', field: 'Oct', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Nov', align: 'center', label: 'Nov', field: 'Nov', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Dec', align: 'center', label: 'Dec', field: 'Dec', sortable: false, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
 ]
const birdTableCellColors ={
  "95" : "#830C5D",
  "90" : "#F16DC6",
  "75" : "#EEB3DA",
  // "1" : "#ffffb2",
  "0"  : "#F7E8F2",
  "-9" : "#a1a1a1"
}

const birdDonutCellColors ={
  "Very High" : "#830C5D",
  "High" : "#F16DC6",
  "Medium" : "#EEB3DA",
  "Low"  : "#F7E8F2",
  "No Data" : "#a1a1a1"
}



const birdMonthLegendTitles = computed(() =>{
    // used in the map legend-- needed so that year is updated
    // when you click on a table column
    const titles = {
        "Jan" : "density (Jan)",
        "Feb" : "density (Feb)",
        "Mar" : "density (Mar)",
        "Apr" : "density (Apr)",
        "May" : "density (May)",
        "Jun" : "density (Jun)",
        "Jul" : "density (Jul)",
        "Aug" : "density (Aug)",
        "Sep" : "density (Sep)",
        "Oct" : "density (Oct)",
        "Nov" : "density (Nov)",
        "Dec" : "density (Dec)",

    }
    return titles
})

const donuts = ref(true)
const resultContentCol = ref(null)
const resultContentColWidth = computed(() => {
  if (resultContentCol.value && !loading){
      return resultContentCol.value.getBoundingClientRect().width;
  }
})

const abundance = ref(true)
const spotlightTabs = ref('dependence')


const infoDialogs = ref({
  coreArea: {
    pName: "% Of Ecoregion that is Core Area",
    model: false,
    text: "This table shows the portion of each ecoregion that is a core area for the selected species.  Due to differences in the offshore and coastal data, 'core areas' are defined differently for each.  Offshore, core areas are those in the 95th percentile for density while in coastal areas, core areas are defined using the 75th percentile. The table shows the percent area of each ecoregion that is considered a 'core area' using these definitions."
  }
  
})
onMounted(() => {
    // console.log(activeSpSpotlight.value)
})

onUnmounted(() =>{
  clearMapStyle()
})



</script>
<style scoped>
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
 .result-pane-header-row{
  border-top: 1px solid white;
}
.pointer{
  cursor: pointer;
}
.circle{
  border-radius: 50%;
  border: 2px solid;
  padding: 2px;
}

.legend-circle{
  border-radius: 50%;
  border: 2px solid;
  min-width: 20px;
}
.purple-10{
  border-color: #470278;
}
.purple-8{
  border-color: #7423ad;
}
.purple-6{
  border-color: #9347c9;
}
.purple-4{
  border-color: #c186eb;
}
.custom-footer{
  min-width:100%;
  
}
.pointer:hover {
  background-color: #464f4b; /* Change to desired hover background color */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow effect */
  border-radius: 5px;
}

.pointer:active {
  background-color: #464f4b; /* Change to desired active background color */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Adjust shadow effect */
  border-radius: 5px;
}
.mapActive{
    background-color: #1D8177;
    color:white;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.rotated-text {
    transform: rotate(270deg); 
    margin-top: 50px;
    margin-right:10px;
  }
.vert-word{
  max-width: 10px !important;

}

</style>